export enum RadioFilterOption {
  All = 'All',
  CurrentYearToDate = 'Current year to date',
  PreviousYear = 'Previous year',
  LastSixMonths = 'Last 6 months',
  Custom = 'Custom'
}

export enum DatepickerType {
  StartDate = 'startDate',
  EndDate = 'endDate'
}
